import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";

export default function Privacy() {
  return (
    <>
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="label-tag mb-3">Documento legale</div>
        <h1 className="font-display font-black text-4xl md:text-5xl uppercase tracking-tighter text-gray-900 mb-2">
          Informativa<br />sulla <span className="text-[#E11D48]">Privacy</span>
        </h1>
        <p className="text-sm text-gray-500 mb-10">Ultimo aggiornamento: 12 maggio 2026</p>

        <section className="prose prose-sm md:prose-base text-gray-500 space-y-6">
          <p>
            Bicyclub ("noi", "la piattaforma") rispetta la tua privacy. Questo documento spiega quali dati personali
            raccogliamo, perché li raccogliamo e come li proteggiamo, in conformità al Regolamento UE 2016/679 (GDPR).
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">1. Titolare del trattamento</h2>
          <p>
            Il titolare del trattamento è Tommaso Davì, contattabile all'indirizzo
            <a href="mailto:info@bicyclub.it" className="text-[#E11D48] underline ml-1">info@bicyclub.it</a>.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">2. Dati che raccogliamo</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Dati di registrazione</strong>: nome, cognome, email, password (in forma cifrata).</li>
            <li><strong>Dati dal login Google</strong> (se scegli "Continua con Google"): nome, email, foto profilo pubblica.</li>
            <li><strong>Dati ciclistici opzionali</strong>: FTP/potenza 20 min, ore in sella mensili, livello di allenamento, bici preferita.</li>
            <li><strong>Dati Strava</strong> (solo se colleghi il tuo account Strava): potenza FTP, ore di attività ultimi 30 giorni, ID Strava.</li>
            <li><strong>Dati dei giri</strong>: località di partenza, percorso, partecipanti, messaggi della chat di gruppo.</li>
            <li><strong>Dati tecnici</strong>: indirizzo IP, user agent del browser, timestamp di accesso (a fini di sicurezza anti brute-force).</li>
          </ul>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">3. Finalità del trattamento</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Creare e gestire il tuo account utente.</li>
            <li>Mostrarti giri ciclistici nella tua zona e permetterti di pubblicare i tuoi.</li>
            <li>Inviarti notifiche email (Resend) e push (Web Push API) per i giri a cui partecipi.</li>
            <li>Sincronizzare i tuoi dati di allenamento se hai collegato Strava.</li>
            <li>Prevenire abusi (es. blocco dopo 5 tentativi di login falliti).</li>
          </ul>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">4. Base giuridica</h2>
          <p>
            Trattiamo i tuoi dati sulla base del <strong>consenso</strong> che fornisci al momento della registrazione
            e sulla base dell'<strong>esecuzione del contratto</strong> (fornirti il servizio Bicyclub).
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">5. Condivisione dei dati</h2>
          <p>I tuoi dati NON vengono venduti a terzi. Li condividiamo solo con i seguenti fornitori, strettamente necessari al funzionamento:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Google</strong> (autenticazione OAuth): se scegli di accedere con Google.</li>
            <li><strong>Strava</strong>: solo se colleghi il tuo account, scambiamo i token OAuth.</li>
            <li><strong>Resend</strong> (Resend Inc., USA): per inviarti email transazionali.</li>
            <li><strong>Photon / OpenStreetMap</strong>: per il geocoding delle località italiane.</li>
            <li><strong>Komoot</strong>: per leggere i metadati dei tour pubblici quando incolli un link.</li>
            <li><strong>Emergent Cloud</strong>: infrastruttura su cui è hostata l'app.</li>
          </ul>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">6. Cookie e tracciamento</h2>
          <p>
            Utilizziamo solo <strong>cookie tecnici essenziali</strong> (token di sessione JWT) per mantenerti loggato.
            Non utilizziamo cookie pubblicitari né strumenti di profilazione di terze parti.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">7. Conservazione dei dati</h2>
          <p>
            Conserviamo i tuoi dati finché il tuo account è attivo. In qualsiasi momento puoi richiedere l'eliminazione
            del tuo account scrivendo a <a href="mailto:info@bicyclub.it" className="text-[#E11D48] underline">info@bicyclub.it</a>.
            I dati verranno cancellati entro 30 giorni.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">8. I tuoi diritti</h2>
          <p>In conformità al GDPR hai il diritto di:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Accedere ai tuoi dati.</li>
            <li>Rettificarli se errati o incompleti.</li>
            <li>Cancellarli ("diritto all'oblio").</li>
            <li>Limitarne il trattamento.</li>
            <li>Riceverli in formato leggibile e trasferirli ad altro servizio (portabilità).</li>
            <li>Opporti al trattamento.</li>
            <li>Proporre reclamo al Garante per la Protezione dei Dati Personali (<a href="https://www.gpdp.it" className="text-[#E11D48] underline" target="_blank" rel="noreferrer">gpdp.it</a>).</li>
          </ul>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">9. Sicurezza</h2>
          <p>
            Le password sono cifrate con bcrypt. Le comunicazioni avvengono via HTTPS con certificato SSL. I cookie di
            sessione sono HttpOnly + Secure + SameSite. I tentativi di login falliti vengono bloccati dopo 5 errori.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">10. Modifiche</h2>
          <p>
            Possiamo aggiornare questa informativa in qualsiasi momento. Le modifiche significative ti verranno
            notificate via email. La data di ultimo aggiornamento è indicata in cima al documento.
          </p>

          <h2 className="font-display font-bold text-xl uppercase tracking-tighter text-gray-900 mt-8">Contatti</h2>
          <p>
            Per qualsiasi richiesta relativa alla tua privacy scrivi a
            <a href="mailto:info@bicyclub.it" className="text-[#E11D48] underline ml-1">info@bicyclub.it</a>.
          </p>
        </section>

        <div className="mt-12 pt-6 border-t border-gray-200 flex flex-wrap gap-4">
          <Link to="/terms" className="text-xs uppercase tracking-wider font-bold text-gray-700 hover:text-gray-900">Termini di servizio →</Link>
          <Link to="/" className="text-xs uppercase tracking-wider font-bold text-gray-700 hover:text-gray-900">← Home</Link>
        </div>
      </main>
    </>
  );
}
